/* eslint-disable jira/filename-case */
import type { Filter } from '@jira/global-pages__directories-filters-directory-v2-common/src/model/index.tsx';
import type { Boards, Users, Groups } from '../model/index.tsx';
import type { State } from './types.tsx';

export const getFilter = (state: State): Pick<Required<Filter>, 'name' | 'id'> & Partial<Filter> =>
	state.appProps.filter;
export const getFilterName = (state: State): string => state.appProps.filter.name;

export const getOnInitialised = (state: State): (() => void) => state.appProps.onInitialised;
export const getOnFilterDeleted = (
	state: State,
): ((filter: Pick<Required<Filter>, 'name' | 'id'> & Partial<Filter>) => void) =>
	state.appProps.onFilterDeleted;
export const getOnFilterDeleteFailed = (
	state: State,
): ((filter: Pick<Required<Filter>, 'name' | 'id'> & Partial<Filter>) => void) =>
	state.appProps.onFilterDeleteFailed;
export const getOnFilterInitiateFailed = (
	state: State,
): ((filter: Pick<Required<Filter>, 'name' | 'id'> & Partial<Filter>) => void) =>
	state.appProps.onFilterInitiateFailed;
export const getOnCancel = (state: State): (() => void) => state.appProps.onCancel;

export const isDeleteInProgress = (state: State): boolean => state.isDeleteInProgress;
export const isDataRetrieved = (state: State): boolean => state.isDataRetrieved;
export const getAssociatedBoards = (state: State): Boards => state.boards;
export const getAssociatedUsers = (state: State): Users => state.users;
export const getAssociatedGroups = (state: State): Groups => state.groups;
export const getCanDelete = (state: State): boolean =>
	Array.isArray(state.boards) && state.boards.length === 0;
